(function () {

  function initRevendeursMap() {

    if (typeof mapboxgl === 'undefined') {
      console.error('Mapbox GL JS non chargé');
      return;
    }

    if (typeof Papa === 'undefined') {
      console.error('PapaParse non chargé');
      return;
    }

    const mapElement = document.getElementById('map');

    if (!mapElement) {
      console.error('Élément #map introuvable');
      return;
    }

    if (mapElement.dataset.initialized === 'true') {
      return;
    }

    mapElement.dataset.initialized = 'true';

    const token = mapElement.dataset.mapboxToken;
    const styleUrl = mapElement.dataset.mapboxStyle;
    const csvUrl = mapElement.dataset.csvUrl;

    if (!token || !styleUrl || !csvUrl) {
      console.error('Token, style Mapbox ou URL CSV manquant');
      return;
    }

    mapboxgl.accessToken = token;

    const map = new mapboxgl.Map({
      container: mapElement,
      style: styleUrl,
      center: [2.5, 46.5],
      zoom: 5
    });

    map.addControl(
      new mapboxgl.NavigationControl({
        showCompass: false
      }),
      'top-right'
    );

    let allFeatures = [];
    let currentFilterType = 'all';

    const cityCache = new Map();

    const labels = {
      restaurant: 'Restaurant',
      bar: 'Bar',
      caviste: 'Cave & épicerie fine',
      distillerie: 'Distillerie'
    };


    /*
    ==============================
    HELPERS
    ==============================
    */

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }


    function getFilteredFeatures() {

      if (currentFilterType === 'all') {
        return allFeatures;
      }

      return allFeatures.filter(function (feature) {
        return feature.properties.type === currentFilterType;
      });
    }


    function updateMapSource(features) {

      const source = map.getSource('revendeurs');

      if (!source) return;

      source.setData({
        type: 'FeatureCollection',
        features: features
      });
    }


    function closeSearchResults() {

      const searchResults =
        document.getElementById('map-search-results');

      if (!searchResults) return;

      searchResults.innerHTML = '';
      searchResults.classList.remove('is-open');
    }


    /*
    ==============================
    REVERSE GEOCODING : VILLE
    ==============================
    */

    async function getCityFromCoordinates(coordinates) {

      const lng = Number(coordinates[0]);
      const lat = Number(coordinates[1]);

      const cacheKey =
        lng.toFixed(5) + ',' + lat.toFixed(5);

      if (cityCache.has(cacheKey)) {
        return cityCache.get(cacheKey);
      }

      const url =
        'https://api.mapbox.com/search/geocode/v6/reverse' +
        '?longitude=' + encodeURIComponent(lng) +
        '&latitude=' + encodeURIComponent(lat) +
        '&types=place,locality' +
        '&language=fr' +
        '&country=fr' +
        '&access_token=' + encodeURIComponent(token);

      try {

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Erreur reverse geocoding');
        }

        const data = await response.json();

        let city = '';

        if (
          data &&
          data.features &&
          data.features.length
        ) {

          const placeFeature =
            data.features.find(function (feature) {
              return feature.properties &&
                feature.properties.feature_type === 'place';
            });

          const localityFeature =
            data.features.find(function (feature) {
              return feature.properties &&
                feature.properties.feature_type === 'locality';
            });

          const selected =
            placeFeature ||
            localityFeature ||
            data.features[0];

          city =
            selected.properties &&
            (
              selected.properties.name ||
              selected.properties.full_address
            )
              ? (
                  selected.properties.name ||
                  selected.properties.full_address
                )
              : '';
        }

        cityCache.set(cacheKey, city);

        return city;

      } catch (error) {

        console.error(
          'Impossible de récupérer la ville',
          error
        );

        return '';
      }
    }


    /*
    ==============================
    POPUP
    ==============================
    */

    async function openFeature(feature, flyToFeature) {

      if (!feature) return;

      const coordinates =
        feature.geometry.coordinates.slice();

      const props =
        feature.properties || {};

      if (flyToFeature) {

        map.flyTo({
          center: coordinates,
          zoom: 14,
          essential: true
        });
      }

      let city = props.city || '';

      if (!city) {

        city =
          await getCityFromCoordinates(
            coordinates
          );

        if (city) {
          props.city = city;
        }
      }

      const typeLabel =
        labels[props.type] ||
        props.type ||
        '';

      const cityHtml =
        city
          ? ' · ' + city
          : '';

      new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: true,
        offset: 12
      })
        .setLngLat(coordinates)
        .setHTML(
          '<div class="revendeur-popup">' +

            '<div class="revendeur-popup__name">' +
              escapeHtml(props.name || '') +
            '</div>' +

            '<div class="revendeur-popup__meta">' +
              escapeHtml(typeLabel) +
              escapeHtml(cityHtml) +
            '</div>' +

          '</div>'
        )
        .addTo(map);
    }


    /*
    ==============================
    FORWARD GEOCODING : VILLE
    ==============================
    */

    async function searchCities(query) {

      const url =
        'https://api.mapbox.com/search/geocode/v6/forward' +
        '?q=' + encodeURIComponent(query) +
        '&types=place,locality' +
        '&country=fr' +
        '&language=fr' +
        '&autocomplete=true' +
        '&limit=5' +
        '&access_token=' + encodeURIComponent(token);

      try {

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Erreur forward geocoding');
        }

        const data = await response.json();

        if (
          !data ||
          !data.features
        ) {
          return [];
        }

        return data.features;

      } catch (error) {

        console.error(
          'Recherche de ville impossible',
          error
        );

        return [];
      }
    }


    /*
    ==============================
    CHARGEMENT DE LA CARTE
    ==============================
    */

    map.on('load', function () {

      Papa.parse(csvUrl, {

        download: true,
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,

        complete: function (results) {

          allFeatures = results.data

            .filter(function (row) {

              return (
                String(row.Visible || '')
                  .trim()
                  .toLowerCase() === 'oui'
              );
            })

            .filter(function (row) {

              return (
                row.Latitude &&
                row.Longitude
              );
            })

            .map(function (row) {

              return {

                type: 'Feature',

                geometry: {

                  type: 'Point',

                  coordinates: [
                    Number(row.Longitude),
                    Number(row.Latitude)
                  ]
                },

                properties: {

                  name:
                    row.Nom || '',

                  type:
                    String(row.Type || '')
                      .trim()
                      .toLowerCase(),

                  city:
                    row.Ville || ''
                }
              };
            });


          /*
          ==============================
          SOURCE
          ==============================
          */

          map.addSource(
            'revendeurs',
            {

              type: 'geojson',

              data: {

                type:
                  'FeatureCollection',

                features:
                  allFeatures
              },

              cluster:
                true,

              clusterMaxZoom:
                14,

              clusterRadius:
                50
            }
          );


          /*
          ==============================
          CLUSTERS
          ==============================
          */

          map.addLayer({

            id:
              'clusters',

            type:
              'circle',

            source:
              'revendeurs',

            filter:
              [
                'has',
                'point_count'
              ],

            paint: {

              'circle-color':
                '#121212',

              'circle-radius': [

                'step',

                ['get', 'point_count'],

                18,

                10,
                22,

                30,
                27,

                80,
                32
              ],

              'circle-stroke-width':
                2,

              'circle-stroke-color':
                '#F9F9F5'
            }
          });


          /*
          ==============================
          NOMBRE CLUSTER
          ==============================
          */

          map.addLayer({

            id:
              'cluster-count',

            type:
              'symbol',

            source:
              'revendeurs',

            filter:
              [
                'has',
                'point_count'
              ],

            layout: {

              'text-field':
                [
                  'get',
                  'point_count_abbreviated'
                ],

              'text-font':
                [
                  'Open Sans Semibold',
                  'Arial Unicode MS Bold'
                ],

              'text-size':
                14
            },

            paint: {

              'text-color':
                '#F9F9F5'
            }
          });


          /*
          ==============================
          POINTS INDIVIDUELS
          ==============================
          */

          map.addLayer({

            id:
              'revendeurs-points',

            type:
              'circle',

            source:
              'revendeurs',

            filter:
              [
                '!',
                [
                  'has',
                  'point_count'
                ]
              ],

            paint: {

              'circle-radius':
                7,

              'circle-color': [

                'match',

                ['get', 'type'],

                'restaurant',
                '#121212',

                'bar',
                '#121212',

                'caviste',
                '#121212',

                'distillerie',
                '#7A1E24',

                '#121212'
              ],

              'circle-stroke-width':
                2,

              'circle-stroke-color':
                '#F9F9F5'
            }
          });


          /*
          ==============================
          CLIC CLUSTER
          ==============================
          */

          map.on(
            'click',
            'clusters',
            function (e) {

              const features =
                map.queryRenderedFeatures(
                  e.point,
                  {
                    layers: [
                      'clusters'
                    ]
                  }
                );

              if (!features.length) {
                return;
              }

              const cluster =
                features[0];

              const clusterId =
                cluster.properties.cluster_id;

              const source =
                map.getSource(
                  'revendeurs'
                );

              source.getClusterExpansionZoom(

                clusterId,

                function (err, zoom) {

                  if (err) {
                    return;
                  }

                  map.easeTo({

                    center:
                      cluster.geometry.coordinates,

                    zoom:
                      zoom
                  });
                }
              );
            }
          );


          /*
          ==============================
          CLIC POINT
          ==============================
          */

          map.on(
            'click',
            'revendeurs-points',
            function (e) {

              if (
                !e.features ||
                !e.features.length
              ) {
                return;
              }

              openFeature(
                e.features[0],
                false
              );
            }
          );


          /*
          ==============================
          CURSEUR
          ==============================
          */

          map.on(
            'mouseenter',
            'clusters',
            function () {

              map.getCanvas()
                .style.cursor =
                'pointer';
            }
          );


          map.on(
            'mouseleave',
            'clusters',
            function () {

              map.getCanvas()
                .style.cursor =
                '';
            }
          );


          map.on(
            'mouseenter',
            'revendeurs-points',
            function () {

              map.getCanvas()
                .style.cursor =
                'pointer';
            }
          );


          map.on(
            'mouseleave',
            'revendeurs-points',
            function () {

              map.getCanvas()
                .style.cursor =
                '';
            }
          );


          /*
          ==============================
          FILTRES
          ==============================
          */

          const filterButtons =
            document.querySelectorAll(
              '.map-filter'
            );

          filterButtons.forEach(
            function (button) {

              button.addEventListener(
                'click',
                function () {

                  currentFilterType =
                    button.dataset.type;

                  filterButtons.forEach(
                    function (btn) {

                      btn.classList.remove(
                        'active'
                      );
                    }
                  );

                  button.classList.add(
                    'active'
                  );

                  updateMapSource(
                    getFilteredFeatures()
                  );

                  const searchInput =
                    document.getElementById(
                      'map-search-input'
                    );

                  if (searchInput) {
                    searchInput.value = '';
                  }

                  closeSearchResults();
                }
              );
            }
          );


          /*
          ==============================
          RECHERCHE
          ==============================
          */

          const searchInput =
            document.getElementById(
              'map-search-input'
            );

          const searchResults =
            document.getElementById(
              'map-search-results'
            );

          let searchTimer = null;


          if (
            searchInput &&
            searchResults
          ) {

            searchInput.addEventListener(
              'input',
              function () {

                clearTimeout(
                  searchTimer
                );

                const query =
                  searchInput.value
                    .trim()
                    .toLowerCase();

                closeSearchResults();


                /*
                Si moins de 2 caractères
                */

                if (
                  query.length < 2
                ) {

                  updateMapSource(
                    getFilteredFeatures()
                  );

                  return;
                }


                /*
                Petit délai pour éviter
                un appel Mapbox à chaque touche
                */

                searchTimer =
                  setTimeout(
                    async function () {


                      /*
                      ==============================
                      1 — RECHERCHE ÉTABLISSEMENTS
                      ==============================
                      */

                      const featuresToSearch =
                        getFilteredFeatures();

                      const establishmentMatches =
                        featuresToSearch

                          .filter(
                            function (
                              feature
                            ) {

                              const props =
                                feature.properties ||
                                {};

                              const name =
                                String(
                                  props.name ||
                                  ''
                                )
                                  .toLowerCase();

                              const city =
                                String(
                                  props.city ||
                                  ''
                                )
                                  .toLowerCase();

                              return (
                                name.includes(
                                  query
                                ) ||
                                city.includes(
                                  query
                                )
                              );
                            }
                          )

                          .slice(
                            0,
                            6
                          );


                      /*
                      ==============================
                      2 — RECHERCHE VILLES MAPBOX
                      ==============================
                      */

                      const cityMatches =
                        await searchCities(
                          query
                        );


                      /*
                      On vide avant affichage
                      */

                      closeSearchResults();


                      /*
                      ==============================
                      ÉTABLISSEMENTS
                      ==============================
                      */

                      establishmentMatches
                        .forEach(
                          function (
                            feature
                          ) {

                            const props =
                              feature.properties ||
                              {};

                            const button =
                              document.createElement(
                                'button'
                              );

                            button.type =
                              'button';

                            button.className =
                              'map-search-result';

                            const typeLabel =
                              labels[
                                props.type
                              ] ||
                              props.type ||
                              '';

                            const meta =
                              props.city
                                ? typeLabel +
                                  ' · ' +
                                  props.city
                                : typeLabel;


                            button.innerHTML =

                              '<span class="map-search-result__name">' +

                                escapeHtml(
                                  props.name ||
                                  ''
                                ) +

                              '</span>' +

                              '<span class="map-search-result__meta">' +

                                escapeHtml(
                                  meta
                                ) +

                              '</span>';


                            button.addEventListener(
                              'click',
                              function () {

                                searchInput.value =
                                  props.name ||
                                  '';

                                closeSearchResults();

                                updateMapSource(
                                  [
                                    feature
                                  ]
                                );

                                openFeature(
                                  feature,
                                  true
                                );
                              }
                            );


                            searchResults
                              .appendChild(
                                button
                              );
                          }
                        );


                      /*
                      ==============================
                      VILLES
                      ==============================
                      */

                      cityMatches
                        .forEach(
                          function (
                            cityFeature
                          ) {

                            const coordinates =
                              cityFeature.geometry &&
                              cityFeature.geometry.coordinates
                                ? cityFeature.geometry.coordinates
                                : null;


                            if (!coordinates) {
                              return;
                            }


                            const props =
                              cityFeature.properties ||
                              {};


                            const cityName =
                              props.name ||
                              props.full_address ||
                              'Ville';


                            const button =
                              document.createElement(
                                'button'
                              );


                            button.type =
                              'button';

                            button.className =
                              'map-search-result';


                            button.innerHTML =

                              '<span class="map-search-result__name">' +

                                escapeHtml(
                                  cityName
                                ) +

                              '</span>' +

                              '<span class="map-search-result__meta">' +

                                'Ville' +

                              '</span>';


                            button.addEventListener(
                              'click',
                              function () {

                                searchInput.value =
                                  cityName;

                                closeSearchResults();


                                /*
                                On remet tous les points
                                correspondant au filtre
                                */

                                updateMapSource(
                                  getFilteredFeatures()
                                );


                                /*
                                Puis on zoome sur la ville.
                                Les points proches seront visibles
                                dans la fenêtre.
                                */

                                map.flyTo({

                                  center:
                                    coordinates,

                                  zoom:
                                    11,

                                  essential:
                                    true
                                });
                              }
                            );


                            searchResults
                              .appendChild(
                                button
                              );
                          }
                        );


                      /*
                      ==============================
                      AUCUN RÉSULTAT
                      ==============================
                      */

                      if (
                        !establishmentMatches.length &&
                        !cityMatches.length
                      ) {

                        searchResults.innerHTML =
                          '<div class="map-search-empty">' +
                            'Aucun résultat' +
                          '</div>';
                      }


                      /*
                      Ouvre le menu
                      */

                      if (
                        searchResults.children.length
                      ) {

                        searchResults
                          .classList.add(
                            'is-open'
                          );
                      }

                    },

                    300
                  );
              }
            );


            /*
            ==============================
            CROIX DU CHAMP SEARCH
            ==============================
            */

            searchInput.addEventListener(
              'search',
              function () {

                if (
                  searchInput.value === ''
                ) {

                  updateMapSource(
                    getFilteredFeatures()
                  );

                  closeSearchResults();
                }
              }
            );


            /*
            ==============================
            CLIC HORS RECHERCHE
            ==============================
            */

            document.addEventListener(
              'click',
              function (event) {

                if (
                  !searchInput.contains(
                    event.target
                  ) &&
                  !searchResults.contains(
                    event.target
                  )
                ) {

                  closeSearchResults();
                }
              }
            );
          }

        },

        error: function (error) {

          console.error(
            'Erreur de chargement CSV',
            error
          );
        }
      });
    });
  }


  /*
  ==============================
  DÉMARRAGE
  ==============================
  */

  function startMap() {

    const mapElement =
      document.getElementById(
        'map'
      );

    if (!mapElement) {
      return;
    }

    initRevendeursMap();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startMap
    );

  } else {

    startMap();
  }


  /*
  ==============================
  ÉDITEUR SHOPIFY
  ==============================
  */

  document.addEventListener(
    'shopify:section:load',
    function () {

      const mapElement =
        document.getElementById(
          'map'
        );

      if (mapElement) {

        mapElement.dataset
          .initialized =
          'false';

        initRevendeursMap();
      }
    }
  );

})();